import React from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../../assets/images/logo.webp';
import classes from '../Logo/Logo.module.css';

const logo = (props) => (
    <NavLink to="/">
        <div className={classes.Logo}>
                <img src={Logo} alt="ao-logo"/>
                <h6>&nbsp;&nbsp;OSHC+</h6>  
        </div>
            
    </NavLink>
);

export default logo;